import { Role } from './Enums';

export default [Role.OWNER, Role.MANAGER, Role.STAFF, Role.SHIPPER];
